module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"}
// module id = react-dom
// module chunks = 0 1 2